<template>
	<section :class="[ 'sk', {'sk--active': active }]">
		<aside :class="['sk__menu']">
			<div class="sk__menu-logo"></div>
			<div class="sk__menu-wrapper">
				<router-view ref="menu" id="menu" name="menu"/>
			</div>
		</aside>
		<main class="sk__content">
			<router-view :user_uid="user_uid" id="content"/>
		</main>
		<div class="sk__menu__bg"></div>
		<!-- <div ref="action" @click="actionToggleActive" class="sk__menu-action">
			<span></span>
			<span></span>
		</div> -->
	</section>
</template>

<script>
export default {
	name: 'app-shell',
	props: [
		'user_uid'
	],
	data() {
		return {
			active: false,
			mediaQuery: null
		}
	},
	methods: {
		toggle() {
			this.active = !this.active
		},
		close() {
			this.active = false
		},
		closeBody(event) {
			if (
				!(this.$refs.menu.$el == event.target || this.$refs.menu.$el.contains(event.target)) &&
				!(document.getElementById('action-menu-toggle') == event.target || document.getElementById('action-menu-toggle').contains(event.target))
			) {
				this.close()
			}
		},
		// updateMatches() {
		// 	this.active = false
		// 	this.inMobile = this.mediaQuery.matches
		// }
	},
	// mounted() {
	// 	// this.mediaQuery = window.matchMedia('(max-width: 480px)')
	// 	this.mediaQuery = window.matchMedia('(max-width: 768px)')
	// 	this.updateMatches()
	// 	this.mediaQuery.addListener(this.updateMatches)
	// },
	// beforeDestroy() {
	// 	if (this.mediaQuery) {
	// 		this.mediaQuery.removeListener(this.updateMatches)
	// 	}
	// },
	created() {
		this.$root.$on('navigation-close', this.close)
		this.$root.$on('navigation-toggle', this.toggle)
		document.body.addEventListener('click', this.closeBody)
		document.body.addEventListener('touchstart', this.closeBody)
	},
	destroyed() {
		this.$root.$off('navigation-close')
		this.$root.$off('navigation-toggle')
		document.body.removeEventListener('click', this.closeBody)
		document.body.removeEventListener('touchstart', this.closeBody)
	}
}
</script>

<style scope>
.sk {
	width: 100vw;
	height: 100vh;
	display: grid;
	grid-template-columns: 250px 1fr;
}
.sk__menu {
	background-color: var(--main-color);
	display: grid;
	grid-template-rows: var(--topbar-height) 1fr;
}
.sk__menu-logo {
	background-color: var(--main-color-dark);
	width: 100%;
	height: 100%;
	background-image: url(/static/svg/logos/logo-white-inline.svg);
	background-size: contain;
	background-repeat: no-repeat;
	background-position: center;
}
.sk__menu-wrapper {
	padding: 0;
}
.sk__content {
	background-color: #fff;
}
.sk__content > section {
	height: 100%;
	width: 100%;
	overflow: hidden;
}
.sk__menu-action {
	display: none;
	position: fixed;
	height: 48px;
	width: 48px;
	bottom: 20px;
	right: 20px;
	/* left:  50%; */
	/* transform: translate(-50%, 0); */
	background-color: #333;
	border-radius: 100%;
	box-shadow: rgba(0,0,0,0.5) 0 0 10px;
	z-index: 2000;
}
.sk__menu-action > span {
	display: block;
	width: 100%;
	height: 100%;
	position: absolute;
	background-position: center;
	background-repeat: no-repeat;
	transition: opacity 0.3s;
}
.sk__menu-action > span:nth-child(1) {
	background-size: 24px;
	background-image: url(/static/svg/buttons/menu.svg);
	opacity: 1;
}
.sk__menu-action > span:nth-child(2) {
	background-size: 18px;
	background-image: url(/static/svg/buttons/close.svg);
	opacity: 0;
}
.sk__menu__bg {
	visibility: hidden;
	position: fixed;
	top: 0;
	left: 0;
	bottom: 0;
	right: 0;
	background-color: rgba(0,0,0,0.5);
	opacity: 0;
	transition: visibility 0s 0.3s, opacity 0.3s 0s;
	z-index: 998;
}

@media screen and (max-width: 768px) {
	.sk {
		grid-template-columns: 1fr;
	}
	.sk__menu {
		position: fixed;
		left: 0;
		top: 0;
		bottom: 0;
		width: 300px;
		z-index: 999;
		transition: transform 300ms;
		box-shadow: rgba(0,0,0,0.5) 0 0 10px;
		transform: translate3d(calc(-100% - 10px),0,0);
	}
	.sk--active > .sk__menu {
		transform: translate3d(0,0,0);
	}
	.sk__menu-action {
		display: block;
	}
	.sk--active .sk__menu__bg {
		transition: visibility 0s 0s, opacity 0.3s 0s;
		visibility: visible;
		opacity: 1;
	}
	.sk--active .sk__menu-action > span:nth-child(1) {
		opacity: 0;
	}
	.sk--active .sk__menu-action > span:nth-child(2) {
		opacity: 1;
	}
}
</style>



// WEBPACK FOOTER //
// src/modules/shell/AppShell.vue